import * as types from '../mutation-types'
import core from '@/js/core/core'
import Vue from 'vue'
import accounting from 'accounting'
import EventBus from '../../events/event-bus'
import vueCookie from 'vue-cookie'
import moment from 'moment'
// import 'moment/locale/zh-cn'

// initial state
const state = {
  betLang: null,
  oddSelected: false,
  betForm: [],
  latestInfo: [],
  BetTypeLang: null,
  int_betType: "",
  int_maxParlayMaxMatch: 10,
  bool_checkSameEvent: true,
  betting: {
    betAllUpList: [],
    betAmountOption: {
      min: 50,
      med: 150,
      big: 250,
      big2: 500,
      big3: 1000,
      max: 0,
    },
    incentive: 1,
    selectedBetAllup: null,
    sErr: null, //smallError
    delayBetTimerId: null
  },
  ajaxBettingList: null,
  allowRequestLatestInfo: true,
  delayBet: null,
  isBetSuccess: false,
  isProcessBet: false,
  isPlacedBet: false,
  pendingFlag: false,
  resizeWHeight: null,
  hdpDisp: window.hdpDisp,
  jsError: { error: false },
  betCombo_jsError: {},
  selectedBetListType: 1,
  selectedBetTab: false,
  openBetForm: false,
  betAmount: '',
  showbetformMenu: false,
  betFormHdpChange: false,
  betFormOddChange: false,
  isBetCombo: false,
  isBetParlay: false,
  comboBetExceedLimit: false,
  betComboAmount: [],
  betComboKeyboardAllow: [],
  // betComboErr: false,
  wgHdpOddNoChgIndex: [],
  allowErrBetAgain: false,
  betMulpAmount: [],
  betMulpAmtFiltered: [],
  disableBet: false,
  dialogToggle: {
    show: false
  },
  selectedMulpBetBoxId: 0,
}

// getters
const getters = {
  betLang: state => state.betLang,
  oddSelected: state => state.oddSelected,
  betForm: state => state.betForm,
  BetTypeLang: state => state.BetTypeLang,
  betting: state => state.betting,
  isBetSuccess: state => state.isBetSuccess,
  isProcessBet: state => state.isProcessBet,
  isPlacedBet: state => state.isPlacedBet,
  pendingFlag: state => state.pendingFlag,
  resizeWHeight: state => state.resizeWHeight,
  hdpDisp: state => state.hdpDisp,
  jsError: state => state.jsError,
  betCombo_jsError: state => state.betCombo_jsError,
  selectedBetTab: state => state.selectedBetTab,
  selectedBetListType: state => state.selectedBetListType,
  latestInfo: state => state.latestInfo,  //push latest-info param 
  betAmountOption: (state, getters) => {
    //return state.betting.betAmountOption

    if (!vueCookie.get(window.compcode + '_acc_' + getters.account.acccode)) {
      // vueCookie.set(window.compcode + '_acc_' + getters.account.acccode, JSON.stringify(state.betting.betAmountOption))
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        data: {
          com_code: window.compcode,
          acc: JSON.stringify(state.betting.betAmountOption),
          acc_code: getters.account.acccode
        },
      }).done((res) => {

      })
      return state.betting.betAmountOption
    } else {
      return JSON.parse(vueCookie.get(window.compcode + '_acc_' + getters.account.acccode))
    }
  },
  delayBet: state => state.delayBet,
  openBetForm: state => state.openBetForm,
  betAmount: state => state.betAmount,
  showbetformMenu: state => state.showbetformMenu,
  betFormHdpChange: state => state.betFormHdpChange,
  betFormOddChange: state => state.betFormOddChange,
  isBetCombo: state => state.isBetCombo,
  isBetParlay: state => state.isBetParlay,
  comboBetExceedLimit: state => state.comboBetExceedLimit,
  betComboAmount: state => state.betComboAmount,
  betComboKeyboardAllow: state => state.betComboKeyboardAllow,
  // betComboErr: state => state.betComboErr,
  wgHdpOddNoChgIndex: state => state.wgHdpOddNoChgIndex,
  allowErrBetAgain: state => state.allowErrBetAgain,
  betMulpAmount: state => state.betMulpAmount,
  betMulpAmtFiltered: state => state.betMulpAmtFiltered,
  disableBet: state => state.disableBet,
  dialogToggle: state => state.dialogToggle,
  selectedMulpBetBoxId: state => state.selectedMulpBetBoxId,
}

// actions
const actions = {
  removeMatch(context, payload) {
    if(!_.isUndefined(payload.data.clearType) && payload.data.clearType=='1'){  //remove betcombo event with error
      let VUE = this
      let removeArr = []
      _.forEach(state.betForm, function(value, key) {
        if((!_.isUndefined(value.error) && !_.isUndefined(value.error.status) && value.error.status=='FAIL') || ((VUE.getters.isBetParlay || VUE.getters.selectedBettype.betTypId == '5') && !_.isUndefined(value.error) && value.error!='')){
          removeArr.push(key)
          if(document.getElementById(value.uniqueId)){
            document.getElementById(value.uniqueId).parentElement.classList.remove('active')
          }
        }
      });
      removeArr = removeArr.sort().reverse()
      _.forEach(removeArr, function(val, id) {
        VUE.commit('REMOVE_MATCH', val)
      });
      Vue.delete(state.betting,'betcomboerror')
      
    } else if (!_.isUndefined(payload.data.clearType) && payload.data.clearType=='2') {  //remove All Match But Last
      this.commit("REMOVE_ALLBUTLAST");

    } else if (!_.isUndefined(payload.data.clearType) && payload.data.clearType=='3') {  //remove bet combo single 
      this.commit('REMOVE_MATCH', payload.data.index)
        
    } else { //remove event 
      var index = _.findIndex(state.betForm, { 'eventObj': { 'eveid': payload.data.eveid } });
      this.commit('REMOVE_MATCH', index)
    }
    
    if (payload) {
      if (payload.callback) {
        return payload.callback();
      }
    }
  },
  confirmBet(context, payload) {
    this.commit('JS_ERR', '')
    if (this.getters.requestAllow == false) {
      return
    }
    var estWinningAmount = 0
    var oddValue = ''
    var STORE = this
    var bettingAmount = this.getters.sportMiniBet.betAmount

    function validateOddBetType(betTyp, odd, oddTyp) {

      if (oddTyp == 'am') {
        if (odd < 0) {
          odd = Math.abs(100 / odd);
        } else {
          odd = (odd / 100);
        }
        odd = odd.toFixed(3);
      } else if ((betTyp == '4' || betTyp == '11' ||
        betTyp == '12' || betTyp == '13' ||
        betTyp == '3' || betTyp == '10' ||
        betTyp == '5' || betTyp == '6' ||
        betTyp == '7' || betTyp == '14' ||
        betTyp == '16' || betTyp == '17' || betTyp == '18' || betTyp == '19' || betTyp == '20' ||

        betTyp == '21' || betTyp == '25' ||
        betTyp == '27' || betTyp == '28' ||
        betTyp == '29' || betTyp == '30' ||
        betTyp == '31' || betTyp == '32' ||
        betTyp == '33' || betTyp == '34' ||
        betTyp == '35' || betTyp == '36' ||
        betTyp == '37' || betTyp == '38' ||
        betTyp == '39' || betTyp == '40' ||
        betTyp == '41' || betTyp == '42' ||
        betTyp == '43' || betTyp == '44' ||
        betTyp == '45' || betTyp == '50' ||
        betTyp == '51' || betTyp == '52' ||
        betTyp == '53' || betTyp == '54' ||
        betTyp == '55' || betTyp == '56' ||
        betTyp == '59' || betTyp == '73' ||
        betTyp == '60' || betTyp == '61' ||
        betTyp == '62' || betTyp == '63' ||
        betTyp == '64' || betTyp == '65' ||
        betTyp == '66' || betTyp == '67' ||
        betTyp == '68' || betTyp == '69' ||
        betTyp == '70' || betTyp == '71' || 
        betTyp == '72' || betTyp == '73' || betTyp == '74' ||
        betTyp == '76' || betTyp == '79' ||
        betTyp == '77' || betTyp == '78' 
      ) && odd > 1) {
          if (betTyp == '3' || betTyp == '10') {
            odd = oddTyp != 'in' ? odd - 1 : odd
          } else {
            odd -= 1
          }
      }

      else if (oddTyp == 'eu' && odd > 1) {
        odd -= 1
      }
      return odd
    }

    if (this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') {
      _.forEach(this.getters.betMulpAmtFiltered, function(arr, id) {
        // var allUpIndex = _.findIndex(this.getters.betting.allUpList, { 'key': this.getters.betting.selectedBetAllup })
        var allUpIndex = _.findIndex(STORE.getters.betting.allUpList, { 'key': arr.allUpKey })
        var mulpParser = STORE.getters.betting.allUpList[allUpIndex].parser.split('#')
        for (let index = 0; index < mulpParser.length; index++) {
          const commaList = mulpParser[index].split(',');
          var ttlOdds = 1
          oddValue = ''
          for (let comma = 0; comma < commaList.length; comma++) {
            const betData = STORE.getters.betForm[commaList[comma]];
            var betOdd = parseFloat(betData.odd)
            if (STORE.getters.account.oddsType == 'am') {
              if (betOdd < 0) {
                betOdd = Math.abs(100 / betOdd);
              } else {
                betOdd = (betOdd / 100);
              }
              betOdd = betOdd.toFixed(2);
            }
            ttlOdds *= betOdd
          }
          oddValue = ttlOdds - 1;
          oddValue = 1;
          // estWinningAmount += this.getters.sportMiniBet.betAmount * oddValue
          estWinningAmount += parseFloat(arr.amount) * oddValue
        } 
      });  
    } else {
      var betOdd = parseFloat(this.getters.betForm[0].odd)
      oddValue = betOdd
      oddValue = (oddValue < 0 && (this.getters.account.oddsType == 'my' || this.getters.account.oddsType == 'in')) ? 1 : validateOddBetType(this.getters.betForm[0].betType, betOdd, this.getters.account.oddsType)
      estWinningAmount = this.getters.sportMiniBet.betAmount * oddValue
    }

    var betFormData = _.cloneDeep(this.getters.betForm)
    _.forEach(betFormData, (value) => {
      value.rca = 0
      value.rcb = 0
      if (value.eventObj.rbinfo) {
        if (value.eventObj.rbinfo.rca) {
          value.rca = value.eventObj.rbinfo.rca
        }
        else if (value.eventObj.rbinfo.rcb) {
          value.rcb = value.eventObj.rbinfo.rcb
        }
      }
      _.unset(value, 'eventObj');
      _.unset(value, 'oddChg');
    })

    if(this.getters.isBetCombo){  //bet combo amount array
      var arr = []
      _.forEach(this.getters.betComboAmount, function(data, key) {
        arr[key] = data.value
      });
      bettingAmount = arr
    }

    // var confirmation = confirm(state.betLang['BETTING.MSG_EST_WIN'] + accounting.formatNumber(parseFloat(estWinningAmount), ',') +
    //   '\n\n' + state.betLang['BETTING.MSG_PROCEED_BET_PLACEMENT'])
    // if (confirmation == true) {
    EventBus.$emit('stopBettingTimer')
    var data = {
      betting: betFormData,
      amount: bettingAmount,
      // amount: this.getters.sportMiniBet.betAmount,
      betterOd: this.getters.account.autoAccBetterOdd,
      oddsType: ((this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') && this.getters.account.oddsType != 'am') ? this.getters.oddTypesList.EU.key : this.getters.account.oddsType,
      isMulp: (this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') ? 1 : 0,
      isCombo: this.getters.isBetCombo ? 1 : 0,
      market: this.getters.selectedMarket
    }

    // pass bet info (index) that is joining promotion 
    if(this.getters.promotionFlag && !this.getters.promotionBetWithoutJoin && !data.isMulp && !this.getters.promotionBetStatus){
      data.promotionBetIndexArr = this.getters.promotionBetIndex
    }

    if (this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') {
      // data.allUp = this.getters.betting.selectedBetAllup
      var amountArr = []
      var allUpArr = []
      _.forEach(this.getters.betMulpAmtFiltered, function(arr, key) {
        amountArr[key] = arr.amount
        allUpArr[key] = arr.allUpKey
      });
      data.amount = amountArr
      data.allUp = allUpArr
      data.minMax = this.getters.betting.minMax
    }
    this.commit('REQUEST_ALLOW', false)

    // if(data.betting[0]['sprtid'] != 1 && this.getters.selectedMarket == 3) {
    if (this.getters.delayBet > 0) {
      this.dispatch('ajaxInitBet', {
        payload: payload,
        data: data
      })
    } else {
      this.dispatch('ajaxConfirmBet', {
        payload: payload,
        data: data
      })
      EventBus.$emit('ttlbetCount')
    }
    // } else {
    //   return;
    // }
  },
  ajaxInitBet(context, payload) {
    let STORE = this
    core.$ajax({
      method: 'post',
      url: window._baseUrl + '/sport-betting/init-bet',
      data: { token: window.token.arr_2 },
    }).done(((res) => {
      var delayTimer = parseInt(res.SYSTEM_DATA.DelayBet) * 1000
      // if(data.betting[0]['sprtid'] != 1 && this.getters.selectedMarket == 3)){
      //   var delayTimer = parseInt(res.SYSTEM_DATA.rbDelayBet) * 1000
      // }
      this.commit('REQUEST_ALLOW', false)
      state.betting.delayBetTimerId = setTimeout((function () {
        this.dispatch('ajaxConfirmBet', {
          payload: payload.payload,
          data: payload.data
        })
      }).bind(this), delayTimer);

    }).bind(this)).catch((errRes) => {
      console.log(errRes)
    })
  },
  ajaxConfirmBet(context, payload) {
    var STORE = this

    // delete payload.data.market
    if (payload.data.betting) {
      _.forEach(payload.data.betting, (data) => {
        _.unset(data, 'title');
        _.unset(data, 'league');
        _.unset(data, 'ta');
        _.unset(data, 'tb');
        _.unset(data, 'league');
        _.unset(data, 'tbetcapt');
        _.unset(data, 'plyTypCap');
        _.unset(data, 'hdpCap');
        _.unset(data, 'uniqueId');
        // 
        if(data.sprtid!='1' && jQuery.inArray(data.betType, ['8','9','10','11','13','16','17','18','20','27','29','31','33','35','37','39','41','43','45','47','49','51','55','56','58','61','64','66','69','71','73']) == '-1') {
        // if (STORE.getters.market.inPlayMarket.key != STORE.getters.selectedMarket) {
          _.unset(data, 'rbscoa');
          _.unset(data, 'rbscob');
          _.unset(data, 'rca');
          _.unset(data, 'rcb');
        }

        _.unset(data, 'error');
        _.unset(data, 'hdpChg');
        _.unset(data, 'oddChg');
        _.unset(data, 'oddChgUpDown');
      })
    }
    var betURL = '/sport-betting/confirm-bet'
    if(this.getters.isBetCombo){
      betURL = '/sport-betting/confirm-combo-bet'
    } else if(this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') {
      betURL = '/sport-betting/confirm-mulp-combo-bet'
    }

    payload.data.token = token.arr_2
    core.$ajax({
      data: payload.data,
      method: 'post',
      url: window._baseUrl + betURL,
    }).done(((res) => {
      var refreshTimer = false
      STORE.commit('REQUEST_ALLOW', true)
      STORE.commit('BETFORM_HDPCHG', false)
      STORE.commit('BETFORM_ODDCHG', false)
      STORE.commit('ALLOW_ERR_BET_AGAIN', false)
      state.allowRequestLatestInfo = true
      state.betting.sErr = null

      //TODO validation for error handler
      if(this.getters.isBetCombo){  //bet combo
        var ret = JSON.parse(res);
        var success = false
        _.forEach(ret.SYSTEM_DATA.betting, function(arr, key) {
          if(arr.error==''){
            _.unset(arr, 'error');
          }
          success = (!_.isUndefined(arr.wgStatus) && (arr.wgStatus=='0'||arr.wgStatus=='2')) ? true : false
        });

        var wgError = _.findIndex(ret.SYSTEM_DATA.betting, {'error': {'status':'FAIL'}})
        var wgPending = _.findIndex(ret.SYSTEM_DATA.betting, {'wgStatus': '1'})
        var wgReject = _.findIndex(ret.SYSTEM_DATA.betting, {'wgStatus': '-1'})
        if(wgPending>-1){ //rb pending exist
          this.commit('BETTING_MESSAGE', {
            isPending: true,
            data: ret.SYSTEM_DATA
          })
        } else if (success && wgPending<0 && wgError<0 && wgReject<0){
          this.commit('BETCOMBO_MESSAGE', { isSuccess: true })
        }
        
        if(wgError>-1){ //has error exist
          this.commit('BETCOMBO_MESSAGE', { isError: true })
        }

        // check if got error hdp change / odd change
        var errCodeAllowBetAgain = ['4003-N', '4010-N'] //, 'N-4018-N'
        var atLeastOneSuccess = _.findIndex(ret.SYSTEM_DATA.betting, function(record) {
          return record.WagerID !== undefined;
        });
        var atLeastOneError = _.findIndex(ret.SYSTEM_DATA.betting, function(record) {
          return record.error !== '' && record.error !== undefined;
        });
        var wgHdpOddNoChgIndex_temp = []
        if(atLeastOneError>-1 && atLeastOneSuccess>-1){
          // get the bet index that do not have error hdp change / odd change
          _.forEach(ret.SYSTEM_DATA.betting, function(arr, key) {
            if(!_.isUndefined(arr.error) && !_.isUndefined(arr.error.code)){
              if(arr.error.code=='4010-N'){
                STORE.commit('BETFORM_HDPCHG', true)
              }
              if(arr.error.code=='4003-N'){
                STORE.commit('BETFORM_ODDCHG', true)
              }
              if(_.includes(errCodeAllowBetAgain, arr.error.code)){
                STORE.commit('ALLOW_ERR_BET_AGAIN', true)
              }
              if(!(_.includes(errCodeAllowBetAgain, arr.error.code))){
                wgHdpOddNoChgIndex_temp.push(key);
              }
            }else{
              wgHdpOddNoChgIndex_temp.push(key);
            }
          });
          this.commit('BETCOMBO_MESSAGE', { isSuccess: true })
          if(!this.getters.miniNormal){
            // var elHeight = $("#singleContainer").height() - 170;
            // $("#singleContainer").height(elHeight);
            setTimeout(function() {
              if(state.betting.betcombosuccess || state.betting.pending) {
                var elHeight = $("#singleContainer").height() + 50;
                $("#singleContainer").height(elHeight);
              }
            }, 1000);
          }
        } else if(atLeastOneError>-1) {
          if(this.getters.miniNormal){
            EventBus.$emit('expandMini')
          }
        }
        this.commit('SET_MATCH_INDEX_NO_ERR', wgHdpOddNoChgIndex_temp)

        //update ccl after betting
        var account = this.getters.account
        account.currCL = ret.SYSTEM_DATA.accCcl
        var currCL_O = ret.SYSTEM_DATA.accCcl * account.currUnit
        account.currCL_O = new Intl.NumberFormat().format(currCL_O)
        STORE.commit('ACCOUNT', account)

        STORE.commit('PROCESS_BET', false)
        if(state.betting.sErr==null){
          // EventBus.$emit('stopBettingTimer', res)
          EventBus.$emit('betSlipCss', true)
          STORE.commit('ODD_SELECTED', false) // added to handle done betting wil auto refresh
        } else {
          Vue.delete(state.betting,'betcombosuccess')
        }

        // STORE.commit("BETCOMBO_AMOUNT", { clear: true });

        this.commit('SPORT_MAPPING_BETTING', {
          newBettingList: ret.SYSTEM_DATA.betting,
          oldBettingList: _.cloneDeep(this.getters.betForm),
          betConfirm: 1,
        })

        // set success status if joined and bet promotion successful
        if(this.getters.promotionFlag && !this.getters.promotionBetStatus) {
          for(const value of this.getters.promotionBetIndex) {
            this.commit('PROMO_SHOW_JOIN_SUCCESS', ret.SYSTEM_DATA.betting[value].promotionBetStatus != undefined? ret.SYSTEM_DATA.betting[value].promotionBetStatus:false)
            this.commit('PROMO_BET_STATUS', ret.SYSTEM_DATA.betting[value].promotionBetStatus != undefined? ret.SYSTEM_DATA.betting[value].promotionBetStatus:false)  
            if(ret.SYSTEM_DATA.betting[value].promotionBetStatus != undefined && ret.SYSTEM_DATA.betting[value].promotionBetStatus == true){
              break
            }
          }
        }
        
      } else if(this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5'){  //bet mulp combo
        var ret = JSON.parse(res);
        
        EventBus.$emit('stopBettingTimer', res)
        STORE.commit('PROCESS_BET', false)
        var wgSuccess = _.findIndex(ret.SYSTEM_DATA.mulpRes, function(record) {
          return record.WagerID !== undefined;
        });
        var wgError = _.findIndex(ret.SYSTEM_DATA.mulpRes, function(record) {
          return record.error !== '';
        });
        if(wgSuccess>-1){
          var pendingFlag = false
          var rbBetTypes = ['8','9','10','11','13','16','17','18','20','27','29','31','33','35','37','39','41','43','45','47','49','51','55','56','58','61','64','66','69','71','73']
          _.forEach(ret.SYSTEM_DATA.betting, (function(value, key) {
              if(rbBetTypes.indexOf(value.betType) != -1 && value.sprtid == '1'){
                  pendingFlag = true
              }
          }).bind(this));

          if(pendingFlag) {
            _.forEach(ret.SYSTEM_DATA.mulpRes, (function(value, key) {
              ret.SYSTEM_DATA.mulpRes[key]['wgStatus'] = '1'
            }).bind(this));

            this.commit('BETTING_MESSAGE', {
              isPending: true,
              data: ret.SYSTEM_DATA
            })
          } else {
            _.forEach(ret.SYSTEM_DATA.mulpRes, (function(value, key) {
              ret.SYSTEM_DATA.mulpRes[key]['wgStatus'] = '0'
            }).bind(this));

            this.commit('BETTING_MESSAGE', {
              isSuccess: true,
              data: ret.SYSTEM_DATA
            })
          }
          
          //update ccl after betting
          if(!_.isUndefined(ret.SYSTEM_DATA.accCcl)){
            var account = this.getters.account
            account.currCL = ret.SYSTEM_DATA.accCcl
            var currCL_O = ret.SYSTEM_DATA.accCcl * account.currUnit
            account.currCL_O = new Intl.NumberFormat().format(currCL_O)
            STORE.commit('ACCOUNT', account)
          }

          EventBus.$emit('betSlipCss', true)
          STORE.commit('ODD_SELECTED', false)
          STORE.commit('BET_SUCCESS', true)

          STORE.commit("BETMULP_AMOUNT", { clear: true });

          this.commit('SPORT_MAPPING_BETTING', {
            newBettingList: ret.SYSTEM_DATA.betting,
            oldBettingList: _.cloneDeep(this.getters.betForm),
            betConfirm: 1,
          })
        } else {
          // this.commit('BETTING_MESSAGE', {
          //   isError: true,
          //   data: ret.SYSTEM_DATA
          // })
          var message = state.betLang['BETTING.LBL_REJECT_BET']
          var errObj = { error:true, msg:message }
          if(wgError>-1){
            var err = ret.SYSTEM_DATA.mulpRes[wgError].error
            message = _.isUndefined(err.message)? message : err.message
            errObj.msg = message
          }
          this.commit('JS_ERR', errObj)
        }
        
        if(this.getters.miniNormal) {
          EventBus.$emit('expandMini')
        }
      } else {  //single/ mulp
      
        if (res.SYSTEM_DATA.status == 'FAIL') {
          this.commit('PROCESS_BET', false)
          this.commit('BETTING_MESSAGE', {
            isError: true,
            data: res.SYSTEM_DATA
          })
          if (res.SYSTEM_DATA.code.indexOf('4022') >= 0) {
            alert(res.SYSTEM_DATA.message + '(' + res.SYSTEM_DATA.code + ')');
            window.location = 'login'
          }
        } else if (res.SYSTEM_DATA.WagerID) {
          //RB check pending
          var wgPending = _.findIndex(res.SYSTEM_DATA.betting, {
            wgStatus: '1'
          })
          if(wgPending>-1){ //rb pending exist
            this.commit('BETTING_MESSAGE', {
              isPending: true,
              data: res.SYSTEM_DATA
            })
          } else {
            this.commit('BETTING_MESSAGE', {
              isSuccess: true,
              data: res.SYSTEM_DATA
            })
          }

          EventBus.$emit('stopBettingTimer', res)
          EventBus.$emit('betSlipCss', true)
          STORE.commit('ODD_SELECTED', false) // added to handle done betting wil auto refresh
          STORE.commit('PROCESS_BET', false)
          STORE.commit('BET_SUCCESS', true)
          // EventBus.$emit('confirmBetSlip', 'betSlipTab');
          if (res.SYSTEM_DATA['betting'][0]['betType'] != '15') {
            //all bettype except MULP
            if (!_.isEmpty(STORE.getters.sportForecastList)) {
              this.dispatch('removeSportForecastList', {
                eveid: res.SYSTEM_DATA['betting'][0]['eveid'],
                ftPlyType: res.SYSTEM_DATA['betting'][0]['plyType'],
                bettypKey: res.SYSTEM_DATA['betting'][0]['betType'],
                tbetKey: res.SYSTEM_DATA['betting'][0]['tbet']
              })
              EventBus.$emit('FORECAST_GETWAITINGLIST', 'nodata')
              EventBus.$emit('FORECAST_CALC', null)
            }
          }
          this.commit('SPORT_MINIBET_BETAMOUNT', res.SYSTEM_DATA['amount'])

          this.commit('SPORT_MAPPING_BETTING', {
            newBettingList: res.SYSTEM_DATA.betting,
            oldBettingList: this.getters.betForm,
            betConfirm: 1,
          })

          // set success status if joined and bet promotion successful
          if(this.getters.promotionFlag && !this.getters.promotionBetStatus) {
            this.commit('PROMO_SHOW_JOIN_SUCCESS', res.SYSTEM_DATA.promotionBetStatus!=undefined? res.SYSTEM_DATA.promotionBetStatus: false)
            this.commit('PROMO_BET_STATUS', res.SYSTEM_DATA.promotionBetStatus!=undefined? res.SYSTEM_DATA.promotionBetStatus: false)
          }
        } else {
          //TODO : small Error
          if (res.SYSTEM_DATA.error) {
            refreshTimer = true
            if (res.SYSTEM_DATA.error.message) {
              state.betting.sErr = res.SYSTEM_DATA.error
            }
            if (res.SYSTEM_DATA.error.code.indexOf('4002') >= 0) {
              //if odds change, session minmax is not found, call latestinfo to get new minmax session
              _.unset(state.latestInfo, 'callback');
              state.betting.firstLoadError = false
              this.dispatch('ajaxLatestInfo', state.latestInfo)
            }
          }
          this.commit('BETTING_MESSAGE', { isError: false })
          this.commit('SPORT_MAPPING_BETTING', {
            newBettingList: res.SYSTEM_DATA.betting,
            oldBettingList: this.getters.betForm
          })
        }
      }

      if (payload) {
        if (payload.callback) {
          return payload.callback(res)
        } else if (payload.payload && payload.payload.callback) {
          if (refreshTimer) {
            return payload.payload.callback(res)
          }
        }
      }
    }).bind(this)).catch((errRes) => {
      console.log(errRes)
    })
  },
  //from betting form refresh
  getBettingInfo(context, payload) {
    var betData = _.cloneDeep(this.getters.betForm);

    // if (this.getters.betting.success && !payload.isRetainSel) {
    //   state.betForm = []
    // }

    payload.betData = betData
    this.dispatch('ajaxLatestInfo', payload)

  },
  //from odds click
  getLatestInfo(context, payload) {
    var betData = [_.cloneDeep(payload.data)]
    //EventBus.$emit('FORECAST_CALC', null)
    if (this.getters.betting.success && this.getters.selectedBettype.betTypId != '5' && !this.getters.isBetParlay) {
      state.betForm = []
    }
    //if is parlay
    if (this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') {
      var sportBetFormList = _.filter(this.getters.betForm, { 'sprtid': payload.data.eventObj.sptid })
      //if next odds select is different sport then clear betForm
      if (sportBetFormList.length == 0) {
        state.betForm = []
        state.betForm = betData
      }
      if (this.getters.sportPrevIsMulp) {
        if ((_.find(this.getters.betForm, { 'eventObj': { 'eveid': payload.data.eventObj.eveid } })) != 'undefined') {
          var index = _.findIndex(this.getters.betForm, { 'eventObj': { 'eveid': payload.data.eventObj.eveid } });
          if (index < 0) {
            var betFormList = _.cloneDeep(this.getters.betForm)
            betData = _.cloneDeep(betData.concat(betFormList))
          } else {
            var storeBetList = _.cloneDeep(this.getters.betForm)
            Vue.set(storeBetList, index, payload.data)
            betData = _.cloneDeep(storeBetList)
          }
        }
      } else {
        this.commit('SPORT_PREVIOUS_IS_MULP', true);
      }
    } else if (this.getters.isBetCombo || payload.isBetCombo) {
      // Check if current sel has selected, if true remove else add

      //betcombo get all selected
      if ((_.find(this.getters.betForm, { 'eventObj': { 'eveid': payload.data.eventObj.eveid } })) != 'undefined') {
        var index = _.findIndex(this.getters.betForm, { 
          'eveid': payload.data.eveid,
          'plyType': payload.data.plyType,
          'betType': payload.data.betType,
          'dual': payload.data.dual,
        });

        if (index < 0) {
          var betFormList = _.cloneDeep(this.getters.betForm)
          betData = _.cloneDeep(betData.concat(betFormList))
        } else {
          var storeBetList = _.cloneDeep(this.getters.betForm)
          Vue.set(storeBetList, index, payload.data)
          betData = _.cloneDeep(storeBetList)
        }
      }
    }
    payload.betData = betData
    payload.token = token.arr_2
    this.dispatch('ajaxLatestInfo', payload)
  },
  ajaxLatestInfo(context, payload) {
    let STORE = this
    if (state.allowRequestLatestInfo == false) {
      return
    }
    if (this.getters.requestAllow == false) {
      return
    }
    state.allowRequestLatestInfo = false
    state.latestInfo = payload
    _.forEach(payload.betData, (data) => {
      _.unset(data, 'fav');
      _.unset(data, 'hdp');
      _.unset(data, 'odd');
      _.unset(data, 'rbscoa');
      _.unset(data, 'rbscob');
      _.unset(data, 'eventObj');
      _.unset(data, 'league');
      _.unset(data, 'ta');
      _.unset(data, 'tb');
      _.unset(data, 'tbetcapt');
      _.unset(data, 'title');
      _.unset(data, 'oddChg');
      _.unset(data, 'oddChgUpDown');
      _.unset(data, 'hdpChg');
      _.unset(data, 'error');
    })
    if (state.betting.sErr && !state.betting.firstLoadError) {
      state.betting.firstLoadError = true
    } else if (state.betting.firstLoadError) {
      state.betting.sErr = null
      state.betting.firstLoadError = false
    }
    core.$ajax({
      data: {
        betting: payload.betData,
        oddsType: ((this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') && this.getters.account.oddsType != 'am') ? this.getters.oddTypesList.EU.key : this.getters.account.oddsType,
        isMulp: (this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') ? 1 : 0,
        isCombo: (this.getters.isBetCombo || payload.isBetCombo) ? 1 : 0,
        market: this.getters.selectedMarket,
        token: payload.token,
        market: this.getters.selectedMarket,
      },
      method: 'post',
      async: false,
      url: window._baseUrl + '/sport-betting/latest-info',
    }).done(((res) => {
      var updateCurrCL = this.getters.account
      updateCurrCL.currCL = res.SYSTEM_DATA.cleft
      this.commit('ACCOUNT', updateCurrCL)
      if (this.getters.requestAllow == false) {
        return
      }
      state.allowRequestLatestInfo = true
      if (typeof res.SYSTEM_DATA.DelayBet !== 'undefined') {
        state.delayBet = res.SYSTEM_DATA.DelayBet
      }

      //TODO : valdiation handler
      if (res.SYSTEM_DATA.status == 'FAIL') {
        this.commit('BETTING_MESSAGE', {
          isError: true,
          data: res.SYSTEM_DATA
        })

        if (res.SYSTEM_DATA.code == 'S-4-S') {
          this.commit('BETTING_CHIP_OPTION', { isBetting: true, minMax: res.SYSTEM_DATA.minMax })
          if (res.SYSTEM_DATA.allUpList) {
            state.betting.allUpList = res.SYSTEM_DATA.allUpList
            // if (state.betting.selectedBetAllup == null) {
            //   state.betting.selectedBetAllup = state.betting.allUpList[0].key
            // } else if (_.findIndex(state.betting.allUpList, { 'key': state.betting.selectedBetAllup }) == -1) {
            //   state.betting.selectedBetAllup = state.betting.allUpList[0].key
            // }
          }
          if (typeof res.SYSTEM_DATA.incentive == 'number') {
            state.betting.incentive = res.SYSTEM_DATA.incentive
          }
          state.ajaxBettingList = res.SYSTEM_DATA.betting
          EventBus.$emit('showBetslip')
          STORE.commit('SELECTED_TAB', 'betSlipTab')
          var active = $('.betSlip').hasClass('active')
          // if (!active) {
          //   $('.betSlip').removeClass('collapsed')
          //   $('.betSlip').addClass('active')
          // }
          var mini = $('.sidebar-first').hasClass('mini')
          if (mini) {
            // $('.widgetArea').find('.scroll-panel').css('overflow', 'visible');
            // $('.widgetArea').find('.scroll-panel').find('.expendScore').css('width', '40em');
            // var collapsed = $('.widgetPanel.betSlip').hasClass('collapsed')
            // if (collapsed) {
            //   $('.widgetPanel.betSlip').removeClass('collapsed')
            // }
            // var collapsed = $('.widgetPanel.betSlip').hasClass('active')
            // if (!collapsed) {
            //   $('.widgetPanel.betSlip').addClass('active');
            // }
          }
          EventBus.$emit('initBettingTimer')
        }
      } else if (res.SYSTEM_DATA.WagerID) {
        this.commit('BETTING_MESSAGE', {
          isSuccess: true,
          data: res.SYSTEM_DATA
        })
      
        EventBus.$emit('showBetslip')
        EventBus.$emit('initBettingTimer')
      } else {

        //if forecast selected refresh score
        if (this.getters.sportForecastSelectedEvent && this.getters.sportForecastSelectedEvent.rbinfo
          && this.getters.sportForecastSelectedEvent.eveid == res.SYSTEM_DATA.betting[0].eveid) {
          var selectedForecast = this.getters.sportForecastSelectedEvent
          if (selectedForecast.rbinfo.scoa != res.SYSTEM_DATA.betting[0].rbscoa
            || selectedForecast.rbinfo.scob != res.SYSTEM_DATA.betting[0].rbscob) {
            selectedForecast.rbinfo.scoa = res.SYSTEM_DATA.betting[0].rbscoa
            selectedForecast.rbinfo.scob = res.SYSTEM_DATA.betting[0].rbscob
            this.commit('SPORTFORECAST_SELECTEDEVENT', selectedForecast)
          }
        }
        this.commit('BETTING_MESSAGE', { isError: false })
        state.betting.minMax = res.SYSTEM_DATA.minMax                     // display max
        // state.betting.betAmountOption.max = res.SYSTEM_DATA.minMax.max    //bet amount keyboard
        this.commit('BETTING_CHIP_OPTION', { isBetting: true, minMax: res.SYSTEM_DATA.minMax }) // need to get the latest chip setting to update keyboard

        if((this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') && res.SYSTEM_DATA.betting.length > 1){
          var firstOccurrencesEvent = {};
          var duplicateEventIndexes = [];
          var earlyEventIndexes = [];
          var rbEventExist = false;
          var hasEarly = false;
          var crossNotAllow = false;
          var allowRBCross = false;
          var earlyMoreThanOneDay = false;

          _.forEach(res.SYSTEM_DATA.betting, (data, index) => {
            if(data.eveid){
              //check if the bet form has same event 
              if (firstOccurrencesEvent[data.eveid] === undefined) {
                firstOccurrencesEvent[data.eveid] = index;
              } else {
                if(!duplicateEventIndexes.includes(firstOccurrencesEvent[data.eveid])){
                  duplicateEventIndexes.push(firstOccurrencesEvent[data.eveid]);
                }
                duplicateEventIndexes.push(index);
              }

              var DateNow = new moment().utcOffset("-04:00").startOf('day').unix()
              var DateTomorrow = new moment().utcOffset("-04:00").add(1, 'days').startOf('day').unix()
              var rbBetTypes = ['8','9','10','11','13','16','17','18','20','27','29','31','33','35','37','39','41','43','45','47','49','51','55','56','58','61','64','66','69','71','73']
              if(window.allowRbParlay) {
                if(rbBetTypes.includes(data.betType.toString())){
                  rbEventExist = true;
                  // check if rb end date end in next day, allow cross
                  if(DateNow == data.event_date_timestamp && DateTomorrow == data.event_end_timestamp) {
                    allowRBCross = true;
                  }
                  if(allowRBCross) {
                      if(!earlyMoreThanOneDay) { // if has early event date diff more than one day with today
                          rbEventExist = false;
                      } else {
                          rbEventExist = true;
                      }
                  }
                } 
  
                if(DateNow < data.event_date_timestamp){
                  hasEarly = true;
                  // check if has early event date diff more than one day with today
                  if(((data.event_date_timestamp - DateNow) / (60 * 60 * 24)) > 1) {
                    earlyMoreThanOneDay = true;
                  }
                  if(allowRBCross) {
                      if(!earlyMoreThanOneDay) {
                          rbEventExist = false;
                      } else {
                          rbEventExist = true;
                      }
                  }
                  if(rbEventExist == true){
                      crossNotAllow = true;
                  }
                } else if(rbEventExist == true && hasEarly == true){
                    crossNotAllow = true;
                }
              } else {
                crossNotAllow = false;
                if(rbBetTypes.includes(data.betType.toString())){
                  crossNotAllow = true;
                }
              }

              if(crossNotAllow) {
                if(!earlyEventIndexes.includes(index)) {
                  earlyEventIndexes.push(index);
                }
              }
            }
          })

          if(earlyEventIndexes && earlyEventIndexes.length>0){
            earlyEventIndexes.forEach((value, id) => {
              if(!duplicateEventIndexes.includes(value)){
                duplicateEventIndexes.push(value);
              }
            });
          }

          if(duplicateEventIndexes && duplicateEventIndexes.length>0){
            duplicateEventIndexes.forEach((value, id) => {
              if(res.SYSTEM_DATA.betting[value].error == undefined || res.SYSTEM_DATA.betting[value].error==''){
                var msg = state.betLang['BETTING.MSG_NOT_SUPPORT_PARLAY']
                var err = {code:"N-4000", message:msg}
                res.SYSTEM_DATA.betting[value].error = err
                this.commit('BETTING_MESSAGE', {
                  isError: true,
                  data: err
                })
              }
            });
          }
        }
        
        if (res.SYSTEM_DATA.allUpList) {
          state.betting.allUpList = []
          state.betting.allUpList = res.SYSTEM_DATA.allUpList
          // if (state.betting.selectedBetAllup == null) {
          //   state.betting.selectedBetAllup = state.betting.allUpList[0].key
          // } else if (_.findIndex(state.betting.allUpList, { 'key': state.betting.selectedBetAllup }) == -1) {
          //   state.betting.selectedBetAllup = state.betting.allUpList[0].key
          // }
          
          if(this.getters.betting.allUpList.length != this.getters.betMulpAmount.length){
            this.commit('SELECTED_MULP_BOX', 0)
            this.commit("BETMULP_AMOUNT", {resetBetMulpAmount: true});
          }
          _.forEach(res.SYSTEM_DATA.allUpList, function(value, i) {
            // cal maxpay
            var maxpay = 0;
            if(res.SYSTEM_DATA.minMax && res.SYSTEM_DATA.minMax.max){
              if(res.SYSTEM_DATA.minMax.maxPay){
                var mulpParser = value.parser.split("#");
                for (let index = 0; index < mulpParser.length; index++) {
                  var ttlOdds = 1;
                  const commaList = mulpParser[index].split(",");
                  for (let comma = 0; comma < commaList.length; comma++) {
                    const betData = res.SYSTEM_DATA.betting[commaList[comma]];
                    var betOdd = parseFloat(betData.odd);
                    if(STORE.getters.account.oddsType=='am'){
                      if(betOdd<0){
                        betOdd=Math.abs(100/betOdd)+1;
                      }else{
                        betOdd= (betOdd / 100)+1;
                      }
                      betOdd= betOdd.toFixed(3);
                    }
                    ttlOdds *= betOdd;
                  }
                  maxpay += res.SYSTEM_DATA.minMax.maxPay/ttlOdds;
                } 
              }
              if(res.SYSTEM_DATA.minMax.max > maxpay){
                maxpay = accounting.toFixed(res.SYSTEM_DATA.minMax.max, 0)
              } else {
                maxpay = accounting.toFixed(maxpay, 0)
              }
            }
            if(STORE.getters.betting.allUpList.length != STORE.getters.betMulpAmount.length 
              || STORE.getters.betting.allUpList[i].key != STORE.getters.betMulpAmount[i].allUp
              || maxpay != STORE.getters.betMulpAmount[i].maxPay){
                var data = {
                  index: i,
                  allUp: STORE.getters.betting.allUpList[i].key,
                  amount: '',
                  stake: '',
                  possiblePayout: '',
                  maxPay: maxpay
                }
                STORE.commit("BETMULP_AMOUNT", data);
                if(STORE.getters.betting.allUpList.length != STORE.getters.betMulpAmount.length){
                  STORE.commit("BETMULP_AMOUNT", {clear: true});
                }
            }
          })
        }
        if (typeof res.SYSTEM_DATA.incentive == 'number') {
          state.betting.incentive = res.SYSTEM_DATA.incentive
        }
        state.ajaxBettingList = res.SYSTEM_DATA.betting
        EventBus.$emit('showBetslip')
        STORE.commit('SELECTED_TAB', 'betSlipTab')
        var active = $('.betSlip').hasClass('active')
        if (!active) {
          $('.betSlip').removeClass('collapsed')
          $('.betSlip').addClass('active')
        }
        var mini = $('.sidebar-first').hasClass('mini')
        if (mini) {
          $('.widgetArea').find('.scroll-panel').css('overflow', 'visible');
          $('.widgetArea').find('.scroll-panel').find('.expendScore').css('width', '40em');
          // $('.widgetArea').find('.mainSection').find('.scroll-content').css('width', '');
          var collapsed = $('.widgetPanel.betSlip').hasClass('collapsed')
          if (collapsed) {
            $('.widgetPanel.betSlip').removeClass('collapsed')
          }
          var collapsed = $('.widgetPanel.betSlip').hasClass('active')
          if (!collapsed) {
            $('.widgetPanel.betSlip').addClass('active');
          }
        }
        EventBus.$emit('initBettingTimer')
      }
      if (payload) {
        if (payload.callback) {
          return payload.callback(res)
        }
      }
    }).bind(this)).catch((errRes) => {
      console.log(errRes)
    })
  }
}

// mutations
const mutations = {

  [types.SPORT_MAPPING_BETTING](state, payload) {
    //map new param into old betting list, if got new column just add into keylist
    var keyList = ['dual', 'fav', 'hdp', 'hdpCap', 'odd', 'rbscoa', 'rbscob', 'plyTypCap', 'minMax'] //, 'wgStatus'
    let VUE = this
    let chkInvalid = false
    
    //Handle single success/combo success/pending
    if(VUE.getters.betting.success || VUE.getters.betting.betcombosuccess || VUE.getters.betting.pending){
      var keyList = ['wgStatus','odd'] //odd for accept better odd update to latest
      if(this.getters.isBetCombo){
        keyList.push("WagerID",'betAmt','error','hdp','hdpCap')
      }
    } else if (!VUE.getters.betting.success && !VUE.getters.betting.betcombosuccess && !VUE.getters.betting.pending){
      //not success/pending, remove wgStatus
      var indexA = keyList.indexOf('wgStatus');
      if(indexA>0){
        keyList.splice(indexA, 1);
      }
    }
    if(this.getters.isBetCombo || VUE.getters.betting.betcomboerror){
      keyList.push('error')
    }
    if((this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') && VUE.getters.betting.error && VUE.getters.betting.error.code){
      keyList = ['error']
    }

    if (payload.newBettingList) {
      for (let index = 0; index < payload.newBettingList.length; index++) {
        const element = payload.newBettingList[index];
        
        if(!VUE.getters.isBetCombo && !VUE.getters.selectedBettype.betTypId == '5' && !VUE.getters.isBetParlay){
          var oldBettingIndex = _.findIndex(payload.oldBettingList, {
            eveid: (!_.isUndefined(payload.chkPendingWager)) ? parseInt(payload.newBettingList[index].eveId) : parseInt(payload.newBettingList[index].eveid)
          })
         
        } else { //betcombo
          var arr = {
            'eveid': parseInt(payload.newBettingList[index].eveid),
            'plyType': payload.newBettingList[index].plyType,
            'betType': payload.newBettingList[index].betType,
            'dual': payload.newBettingList[index].dual
          }
          if(!_.isUndefined(payload.chkPendingWager)){  //check pending return format param
            var arr = {
              'eveid': parseInt(payload.newBettingList[index].eveId),
              'plyType': payload.newBettingList[index].plyTypId,
              'betType': payload.newBettingList[index].betTypId,
              'dual': payload.newBettingList[index].dual
            }
          }

          if(VUE.getters.selectedBettype.betTypId=='6'){  //OTR
            var arr2 = { 'tbet': parseInt(payload.newBettingList[index].tbet) }
            arr = Object.assign(arr, arr2);
          }
          var oldBettingIndex = _.findIndex(payload.oldBettingList, arr)

          if(VUE.getters.isBetCombo){
            if(_.isUndefined(VUE.getters.betComboAmount[oldBettingIndex])){
              var data = { index:oldBettingIndex, amount:'' }
              VUE.commit("BETCOMBO_AMOUNT", data);
            }
            if(_.isUndefined(VUE.getters.betComboKeyboardAllow[oldBettingIndex])){
              var kdata = { index:oldBettingIndex, settings: {min: true, med: true, big: true, big2: true, big3: true} }
              VUE.commit("BETCOMBO_KEYBOARDALLOW", kdata);
            }
          }
        }

        if(!_.isUndefined(payload.isRetainSel) && payload.isRetainSel){
          _.unset(payload.oldBettingList[oldBettingIndex], 'error');
        }

        //unset after return to bet form/ retain
        if(!VUE.getters.betting.success && !VUE.getters.betting.betcombosuccess && !VUE.getters.betting.pending){
          _.unset(payload.oldBettingList[oldBettingIndex], 'WagerID');
          _.unset(payload.oldBettingList[oldBettingIndex], 'betAmt');
          _.unset(payload.oldBettingList[oldBettingIndex], 'wgStatus');
        }

        if(_.isUndefined(payload.newBettingList[index]['error'])){
          _.unset(payload.oldBettingList[oldBettingIndex], 'error');
        }
        
        keyList.forEach(value => {
          //check odd change
          if (value == 'odd') {  
            if(this.getters.isBetCombo){
              if(!_.isUndefined(payload.newBettingList[index]['error'])){
            //     return
                if ((!_.isUndefined(payload.oldBettingList[oldBettingIndex][value]) || !_.isUndefined(payload.newBettingList[index][value])) && parseFloat(payload.oldBettingList[oldBettingIndex][value]) != parseFloat(payload.newBettingList[index][value])) {
                  // payload.oldBettingList[oldBettingIndex]['oddChg'] = true
                  Vue.delete(state.betting, 'betcombosuccess')
                  // od up/down
                  if(parseFloat(payload.oldBettingList[oldBettingIndex][value]) > parseFloat(payload.newBettingList[index][value])) {
                    payload.oldBettingList[oldBettingIndex]['oddChgUpDown'] = 'up'
                  }else{
                    payload.oldBettingList[oldBettingIndex]['oddChgUpDown'] = 'down'
                  }
                } else {
                  payload.oldBettingList[oldBettingIndex]['oddChg'] = false
                  payload.oldBettingList[oldBettingIndex]['oddChgUpDown'] = ''
                }
              }
            }
            if(!this.getters.isBetCombo){
              if(VUE.getters.betting.success || VUE.getters.betting.betcombosuccess || VUE.getters.betting.pending){
                return ////odd for accept better odd update to latest, wont show oddchange
              }
              if ((!_.isUndefined(payload.oldBettingList[oldBettingIndex][value]) || !_.isUndefined(payload.newBettingList[index][value])) && parseFloat(payload.oldBettingList[oldBettingIndex][value]) != parseFloat(payload.newBettingList[index][value])) {
                payload.oldBettingList[oldBettingIndex]['oddChg'] = true
                // od up/down
                if(parseFloat(payload.oldBettingList[oldBettingIndex][value]) > parseFloat(payload.newBettingList[index][value])) {
                  payload.oldBettingList[oldBettingIndex]['oddChgUpDown'] = 'up'
                }else{
                  payload.oldBettingList[oldBettingIndex]['oddChgUpDown'] = 'down'
                }
              } else {
                payload.oldBettingList[oldBettingIndex]['oddChg'] = false
                payload.oldBettingList[oldBettingIndex]['oddChgUpDown'] = ''
              }

              STORE.commit('BETFORM_ODDCHG', payload.oldBettingList[oldBettingIndex]['oddChg'])
            }
          }
          //check HDP change
          if (value=='hdp') {
            // if(this.getters.isBetCombo){  
            //   if(!_.isUndefined(payload.newBettingList[index]['error'])){
            //     return
            //   }
            // }
            if(!this.getters.isBetCombo){
              if ((!_.isUndefined(payload.oldBettingList[oldBettingIndex][value]) || !_.isUndefined(payload.newBettingList[index][value])) && parseFloat(payload.oldBettingList[oldBettingIndex][value]) != parseFloat(payload.newBettingList[index][value])) {
                payload.oldBettingList[oldBettingIndex]['hdpChg'] = true
              } else {
                payload.oldBettingList[oldBettingIndex]['hdpChg'] = false
              }
              this.commit('BETFORM_HDPCHG', payload.oldBettingList[oldBettingIndex]['hdpChg'])
            }
          }
          //confirm combobet chk wgstatus / is error
          if (value=='wgStatus' || value=='WagerID' || value=='betAmt'){
            if(VUE.getters.isBetCombo){
              if(_.isUndefined(payload.newBettingList[index][value]) && !_.isUndefined(payload.newBettingList[index]['error'])){
                return
              }
              if(payload.chkPendingWager && !_.isUndefined(payload.oldBettingList[oldBettingIndex][value]) && _.isUndefined(payload.newBettingList[index][value])){
                return
              }
            }

          }
          
          if(!_.isUndefined(payload.newBettingList[index][value]) && oldBettingIndex > -1 ){
          // if(!_.isUndefined(payload.oldBettingList[oldBettingIndex][value]) || !_.isUndefined(payload.newBettingList[index][value]) ){
            payload.oldBettingList[oldBettingIndex][value] = payload.newBettingList[index][value]
          }
          
          if(this.getters.isBetCombo && value=='error'){
            if(!_.isUndefined(payload.newBettingList[index][value]) && payload.newBettingList[index][value]!=''){
              payload.oldBettingList[oldBettingIndex][value] = payload.newBettingList[index][value]
              chkInvalid = true
              // if(!state.betComboErr){
                // this.commit('BETCOMBO_ERROR', true)
                if(payload.newBettingList[index][value].code=='4010-N'){
                  this.commit('BETFORM_HDPCHG', true)
                }
                if(payload.newBettingList[index][value].code=='4003-N'){
                  this.commit('BETFORM_ODDCHG', true)
                }
                Vue.set(state.betting, 'betcomboerror', {
                  code: payload.newBettingList[index][value].code,
                  message: payload.newBettingList[index][value].message,
                })
              // }
            } else if (_.isUndefined(payload.newBettingList[index][value])){ // && state.betComboErr
              _.unset(payload.oldBettingList[oldBettingIndex], 'error');
            }
            if(payload.oldBettingList[oldBettingIndex][value]=='' && payload.newBettingList[index][value]==''){
              _.unset(payload.oldBettingList[oldBettingIndex], 'error');
            }
            if(((!_.isUndefined(payload.newBettingList[index][value]) && payload.newBettingList[index][value]=='')||(!_.isUndefined(payload.newBettingList[index]['WagerID']))) && payload.oldBettingList[oldBettingIndex][value]!=''){
              _.unset(payload.oldBettingList[oldBettingIndex], 'error');
            }
          }
        })
      }

      if(this.getters.isBetCombo && !chkInvalid){
        Vue.delete(state.betting,'betcomboerror')
      }
    }

    //handle S-4-S err
    //remove new bettype not allow under prefix
    if (!_.isUndefined(this.getters.betting.error) && this.getters.betting.error.code == 'S-4-S') {
      if (payload.oldBettingList.length != payload.newBettingList.length) {
        for (let index = 0; index < payload.oldBettingList.length; index++) {
          const element = payload.oldBettingList[index];

          var newBettingList = _.findIndex(payload.newBettingList, {
            eveid: String(payload.oldBettingList[index].eveid)
          })
          if (newBettingList == -1) {
            payload.oldBettingList.splice(index, 1)
          }
        }
      }
    }

    if(this.getters.selectedBettype.betTypId != '5' && !this.getters.isBetParlay) { // no mulp
      var wgPending = _.findIndex(payload.newBettingList, { 'wgStatus': '1' })
      if(wgPending<0){ //no pending
        VUE.commit('BETTING_MESSAGE', { isPending: false });
        EventBus.$emit('stopBettingTimer')
        if(this.getters.isBetCombo && payload.chkPendingWager && wgPending<0){
          VUE.commit('BETCOMBO_MESSAGE', { isSuccess: true })
        }
      }
    }
    if(!_.isUndefined(payload.chkPendingWager)){
      if(VUE.getters.betting.reject){
        EventBus.$emit('stopBettingTimer');
      }
    }
    state.betForm = []
    state.betForm = payload.oldBettingList
  },

  [types.BETLANG](state, payload) {
    state.betLang = payload
  },

  [types.ODD_SELECTED](state, payload) {
    state.oddSelected = payload
  },

  [types.BET_FORM](state, payload) {
    var betData = payload.oldBetData
    // if(this.getters.selectedBettype.betTypId == '5' || this.getters.isBetParlay){
    //   if (state.int_betType != this.getters.selectedBettype.betTypId && this.getters.isParlayTab) {
    //     state.betForm = []
    //   }
    // }
    if(this.getters.betting.success || this.getters.betting.betcombosuccess){
      state.betForm = []
      // if(this.getters.isBetCombo){
      //   Vue.delete(state.betting, 'betcombosuccess')
      // } else {
      //   Vue.delete(state.betting, 'success')
      // }
      this.commit("CLEAR_BET_SUCCESS");
      // clear selected odds
      //clear msg
    }

    if (this.getters.selectedBettype.betTypId == 5 || this.getters.isBetParlay) {
      state.int_betType = this.getters.selectedBettype.betTypId
      // if(state.betForm.length == 2){
      if (state.betForm.length != 0) {
        if ((_.find(state.betForm, { 'eventObj': { 'eveid': betData.eventObj.eveid } })) != undefined || (_.find(state.betForm, { 'eveid': betData.eventObj.eveid })) != undefined) {
          var index = _.findIndex(state.betForm, { 'eventObj': { 'eveid': betData.eventObj.eveid } });
          if(index < 0) {
            index = _.findIndex(state.betForm, { 'eveid': betData.eventObj.eveid });
          }
          
          if (index >= 0) {
            Vue.set(state.betForm, index, betData)
          } else {
            state.betForm.push(betData)
          }
        } else {
          state.betForm.push(betData)
        }
      } else {
        state.betForm.push(betData)
      }
      // }else{
      //   state.betForm[0] = payload
      // }
    } else if(this.getters.isBetCombo) {  
      var arr = {
        'eveid': parseInt(betData.eveid),
        'plyType': betData.plyType,
        'betType': betData.betType,
        'dual': betData.dual
      }
      if(this.getters.selectedBettype.betTypId=='6'){ //OTR
        var arr2 = {
          'tbet': betData.tbet
        }
        arr = Object.assign(arr, arr2);
      }

      if (state.betForm.length != 0) {
        if ((_.find(state.betForm, { 'eventObj': { 'eveid': betData.eventObj.eveid } })) != 'undefined') {
          // var index = _.findIndex(state.betForm, { 'eventObj': { 'eveid': betData.eventObj.eveid } });
          var index = _.findIndex(state.betForm, arr)
          if (index >= 0) {
            Vue.set(state.betForm, index, betData)
          } else {
            state.betForm.push(betData)
          }
        } else {
          state.betForm.push(betData)
        }
      } else {
        state.betForm.push(betData)
      }

      //if betcombo amt key empty insert ''
      //add new bet, set newbet key amount
      var id = _.findIndex(this.getters.betForm, arr)
      if(id >= 0 && _.isUndefined(this.getters.betComboAmount[id])){
        var data = {
          index: id,
          amount: ''
        }
        var kdata = { index:id, settings: {min: true, med: true, big: true, big2: true, big3: true} }

        this.commit("BETCOMBO_AMOUNT", data);
        this.commit("BETCOMBO_KEYBOARDALLOW", kdata);
      }
      this.commit("BETCOMBO_AMOUNT", {clear: true});  //reset other betcombo amount
      this.commit("BETCOMBO_KEYBOARDALLOW", {clear: true});  //reset other betcombo keyboard alow
    } else {
      // if (state.int_betType == this.getters.selectedBettype.betTypId) {
        state.betForm = []
      // }
      state.int_betType = this.getters.selectedBettype.betTypId
      state.betForm.push(betData)
    }
    this.commit('SPORT_MAPPING_BETTING', {
      newBettingList: payload.newBettingList,
      oldBettingList: state.betForm
    })
  },
  [types.BETTYPELANG](state, payload) {
    state.BetTypeLang = payload
  },

  [types.REMOVE_MATCH](state, payload) {
    if (payload.removeAll) {
      state.betForm = []
    } else {
      state.betForm.splice(payload, 1)
    }
    if((this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') && !this.getters.isParlayTab && state.betForm.length == 0){
      this.commit('SELECTED_BETTYPE', this.getters.previousBettype.bettype)
      this.commit('IS_BETCOMBO', this.getters.previousBettype.isBetCombo)
    }
    state.oddSelected = state.betForm.length == 0 ? false : true
  },

  [types.REMOVE_ALLBUTLAST](state, payload) {
    let a = state.betForm.length * -1
    let b = state.betForm.length - 1

    _.forEach(state.betForm, function(value, key) {
      if((key+1)==state.betForm.length){
      } else {
        document.getElementById(value.uniqueId).parentElement.classList.remove('active')
      }
    });

    state.betForm.splice(a, b);

  },

  [types.BETTING_CHIP_OPTION](state, payload) {
    var betAmountOption = {
      min: 0,
      med: 0,
      big: 0,
      big2: 0,
      big3: 0,
    }

    if (payload && payload.isBetting) {
      if (!vueCookie.get(window.compcode + '_acc_' + this.getters.account.acccode)) {
        // vueCookie.set(window.compcode + '_acc_' + this.getters.account.acccode, JSON.stringify(state.betting.betAmountOption))
        $.ajax({
          method: 'post',
          url: _baseUrl + '/callCookies',
          data: {
            com_code: window.compcode,
            acc: JSON.stringify(state.betting.betAmountOption),
            acc_code: this.getters.account.acccode
          },
        }).done((res) => {

        })
        betAmountOption = state.betting.betAmountOption
      } else {
        betAmountOption = JSON.parse(vueCookie.get(window.compcode + '_acc_' + this.getters.account.acccode))
      }
      betAmountOption.max = payload.minMax.max
      state.betting.minMax = payload.minMax
    } else {
      betAmountOption = {
        min: payload.min,
        med: payload.med,
        big: payload.big,
        big2: payload.big2,
        big3: payload.big3,
      }
    }
    state.betting.betAmountOption = betAmountOption
    // vueCookie.set(window.compcode + '_acc_' + this.getters.account.acccode, JSON.stringify(state.betting.betAmountOption))
    $.ajax({
      method: 'post',
      url: _baseUrl + '/callCookies',
      data: {
        com_code: window.compcode,
        acc: JSON.stringify(state.betting.betAmountOption),
        acc_code: this.getters.account.acccode
      },
    }).done((res) => {

    })
  },

  [types.BETTING_BETAMOUNT_OPTION](state, payload) {
    var betAmountOption = {
      min: payload.min,
      max: payload.max
    }
    betAmountOption.med = betAmountOption.min * 5
    betAmountOption.big = betAmountOption.med * 5

    if (payload.minCombo)
      betAmountOption.minCombo = payload.minCombo
    if (payload.maxCombo)
      betAmountOption.maxCombo = payload.maxCombo

    state.betting.betAmountOption = betAmountOption
  },

  [types.BETTING_MESSAGE](state, payload) {
    if (payload.isError) {
      Vue.set(state.betting, 'error', {
        code: payload.data.code,
        message: payload.data.message,
      })
      //show err at betform
      // if (payload.data.code != 'S-4-S') {
      //   if(payload.data.code != 'N-4000-N'){ //Event Close
      //     this.commit('SPORT_MINIBET_TOGGLE', false)
      //     this.commit('REMOVE_MATCH', { removeAll: true })
      //     this.commit('ODD_SELECTED', false)
      //   }
      // }
    } else if (payload.isSuccess || payload.isPending) {
      //bet success from confirmbet, not from checking pending success
      if(_.isUndefined(payload.isPendingSuccess)){  
        var account = this.getters.account
        account.currCL = payload.data.accCcl
        var currCL_O = payload.data.accCcl * account.currUnit
        account.currCL_O = new Intl.NumberFormat().format(currCL_O)
        var successPending = (payload.isSuccess) ? 'success' : 'pending'
        this.commit('ACCOUNT', account)
      } else {
        EventBus.$emit('stopBettingTimer');
      }
      
      // Vue.set(state.betting, 'success', {
      Vue.set(state.betting, successPending, {
        data: payload.data,
      })
    } else if (payload.isReject) {
      Vue.set(state.betting, 'reject', {
        data: {reject: true},
        // data: payload.data,
      })
    } else if (!_.isUndefined(payload.isPending) && !payload.isPending) {
      Vue.delete(state.betting, 'pending')
      return
      
    } else {
      Vue.delete(state.betting, 'pending')
      Vue.delete(state.betting, 'success')
      Vue.delete(state.betting, 'error')
      Vue.delete(state.betting, 'reject')
    }
  },

  [types.BETCOMBO_MESSAGE](state, payload) {
    if (payload.isClear) {
      Vue.delete(state.betting, 'betcombosuccess')
      Vue.delete(state.betting, 'betcomboerror')
    } else if (payload.isClearErr){
      Vue.delete(state.betting, 'betcomboerror')
    } else if (payload.isSuccess){
      Vue.set(state.betting, 'betcombosuccess', true)
    } else if (payload.isError){
      Vue.set(state.betting, 'betcomboerror', true)
    }
  },

  [types.BETTING_ALLUP](state, payload) {
    if (payload) {
      state.betting.selectedBetAllup = payload
    }
  },

  [types.BETTING_DELAY_TIMERID](state, payload) {
    if (state.betting.delayBetTimerId) {
      this.commit('REQUEST_ALLOW', true)
      clearTimeout(state.betting.delayBetTimerId)
    }
    state.betting.delayBetTimerId = payload
  },

  [types.BET_SUCCESS](state, payload) {
    state.isBetSuccess = payload
  },

  [types.PROCESS_BET](state, payload) {
    state.isProcessBet = payload
  },

  [types.PLACED_BET](state, payload) {
    state.isPlacedBet = payload
  },

  [types.PENDING_FLAG](state, payload) {
    state.pendingFlag = payload
  },

  [types.RESIZE_WHEIGHT](state, payload) {
    state.resizeWHeight = payload
  },

  [types.JS_ERR](state, payload) {
    state.jsError = payload
  },

  [types.BETCOMBO_JS_ERR](state, payload) {
    state.betCombo_jsError = payload
  },

  [types.BETLIST_TYPE](state, payload) {
    state.selectedBetListType = payload
  },

  [types.SELECTED_BETTAB](state, payload) {
    state.selectedBetTab = payload
  },

  [types.OPEN_BETFORM](state, payload) {
    state.openBetForm = payload
  },

  [types.BET_AMOUNT](state, payload) {
    state.betAmount = payload
  },

  [types.SHOW_BETFORM_MENU](state, payload) {
    state.showbetformMenu = payload
  },

  [types.BETFORM_HDPCHG](state, payload) {
    state.betFormHdpChange = payload
  },
  
  [types.BETFORM_ODDCHG](state, payload) {
    state.betFormOddChange = payload
  },

  [types.IS_BETCOMBO](state, payload) {
    state.isBetCombo = payload
  },
  IS_BETPARLAY(state, payload) {
    state.isBetParlay = payload
  },

  [types.COMBOBET_EXCEEDLIMIT](state, payload) {
    state.comboBetExceedLimit = payload
  },

  [types.BETCOMBO_AMOUNT](state, payload) {
    function commasAmount(amount) {
      amount += '';
      var x = amount.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      return x1 + x2;
    }
    if(payload.clear){
      // state.betComboAmount = []
      var comboAmountArr = _.cloneDeep(state.betComboAmount)
      let clearAll = {value: ''}

      const newItems = comboAmountArr.map((item) => {
        item.value = clearAll.value
        return item
      })
      state.betComboAmount = newItems
    } else if (payload.spliceIndex) {
      state.betComboAmount.splice(payload.index, 1)
    } else if (payload.resetBetComboAmount) {
      state.betComboAmount = []; // Reset betComboAmount to an empty array
    } else {
      state.betComboAmount[payload.index] = {}
      var clone = _.cloneDeep(state.betComboAmount)
      var fixedAccountingNumber = (payload.amount=='') ? "" : accounting.toFixed(payload.amount, 0);
      clone[payload.index] = { value: commasAmount(fixedAccountingNumber) }
      state.betComboAmount = []
      state.betComboAmount = clone
    }
  },

  [types.BETCOMBO_KEYBOARDALLOW](state, payload) {
    if(payload.clear){
      var comboAmountArr = _.cloneDeep(state.betComboKeyboardAllow)

      const newItems = comboAmountArr.map((item) => {
        item.min = true
        item.med = true
        item.big = true
        item.big2 = true
        item.big3 = true
        return item
      })
      state.betComboKeyboardAllow = newItems
    } else if (payload.spliceIndex) {
      state.betComboKeyboardAllow.splice(payload.index, 1)
    } else {
      state.betComboKeyboardAllow[payload.index] = {}
      var clone = _.cloneDeep(state.betComboKeyboardAllow)
      clone[payload.index] = payload.settings
      state.betComboKeyboardAllow = []
      state.betComboKeyboardAllow = clone
    }

  },

  // [types.BETCOMBO_ERROR](state, payload) {
  //   state.betComboErr = payload
  // },

  [types.CLEAR_BET_SUCCESS](state, payload) {
    if(this.getters.isBetCombo){
      Vue.delete(state.betting, 'betcombosuccess')
    } else {
      Vue.delete(state.betting, 'success')
    }
  },

  [types.SET_MATCH_INDEX_NO_ERR](state, payload) {
    // SET MATCH INDEX THAT NO HDP/ODD CHG ERR
    state.wgHdpOddNoChgIndex = payload
  },

  [types.ALLOW_ERR_BET_AGAIN](state, payload) {
    // allow continue bet for specific errors
    state.allowErrBetAgain = payload
  },

  [types.BETMULP_AMOUNT](state, payload) {
    function commasAmount(amount) {
      amount += '';
      var x = amount.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      return x1 + x2;
    }
    if(payload.clear){
      var mulpAmountArr = _.cloneDeep(state.betMulpAmount)
      let clearAll = {value: '', stake: '', possiblePayout: ''}

      const newItems = mulpAmountArr.map((item) => {
        item.value = clearAll.value
        item.stake = clearAll.stake
        item.possiblePayout = clearAll.possiblePayout
        // item = clearAll
        return item
      })
      state.betMulpAmount = newItems
    } else if (payload.spliceIndex) {
      state.betMulpAmount.splice(payload.index, 1)
    } else if (payload.resetBetMulpAmount) {
      state.betMulpAmount = []; // Reset betMulpAmount to an empty array
    } else {
      state.betMulpAmount[payload.index] = {}
      var clone = _.cloneDeep(state.betMulpAmount)
      var fixedAccountingNumber = ''
      fixedAccountingNumber = (_.isUndefined(payload.amount) || payload.amount=='') ? "" : accounting.toFixed(payload.amount, 0);
      // clone[payload.index] = { value: commasAmount(fixedAccountingNumber) }
      clone[payload.index].value = commasAmount(fixedAccountingNumber)
      fixedAccountingNumber = (_.isUndefined(payload.stake) || payload.stake=='') ? "" : accounting.toFixed(payload.stake, 0);
      clone[payload.index].stake = commasAmount(fixedAccountingNumber)
      fixedAccountingNumber = (_.isUndefined(payload.possiblePayout) || payload.possiblePayout=='') ? "" : accounting.toFixed(payload.possiblePayout, 0);
      clone[payload.index].possiblePayout = commasAmount(fixedAccountingNumber)
      clone[payload.index].allUp = payload.allUp
      clone[payload.index].maxPay = (_.isUndefined(payload.maxPay) || payload.maxPay=='') ? "" : accounting.toFixed(payload.maxPay, 0);
      state.betMulpAmount = []
      state.betMulpAmount = clone
    }
  },

  [types.BETMULP_AMOUNT_FILTERED](state, payload) {
    state.betMulpAmtFiltered = payload
  },

  [types.DIALOG_TOGGLE](state, payload) {
    if(payload.reset){
      state.dialogToggle = {show:false}
    } else {
      state.dialogToggle = payload
    }
  },

  [types.DISABLE_BET](state, payload) {
    state.disableBet = payload
  },

  [types.SELECTED_MULP_BOX](state, payload) {
    state.selectedMulpBetBoxId = payload
  },

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/wob/vue/store/modules/bet.js